import Keycloak from "keycloak-js";
import { deleteCookie, setSessionCookie } from './utils';

const keycloak = new Keycloak({
    // @ts-ignore
    url: window.env.keycloak.url,
    // @ts-ignore
    realm: window.env.keycloak.realm,
    // @ts-ignore
    clientId: window.env.keycloak.clientId
});

export const reAuth = async (): Promise<boolean> => {
    try {
        // If token is still valid, nothing to do
        if (!keycloak.isTokenExpired(5)) {
            return true;
        }

        // Token is expired — try to refresh
        const tokenRefreshed = await keycloak.updateToken(5);

        if (tokenRefreshed && keycloak.token) {
            // Store new token in cookie if refresh succeeded
            setSessionCookie("JWT_TOKEN", keycloak.token);
            return true;
        } else {
            // Refresh failed — clear cookie and redirect to login
            deleteCookie("JWT_TOKEN");
            keycloak.login();
            return false;
        }
    } catch (error) {
        console.error("🔒 ReAuth failed:", error);
        deleteCookie("JWT_TOKEN");
        keycloak.login();
        return false;
    }
};

export default keycloak;